/* Matchwell theme script. No dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cfg = window.Matchwell || {};
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents || 0) / 100;
    var pick = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var kind = pick ? pick[1] : 'amount';
    var withDelims = function (n, dec, thou, sep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
    };
    var out;
    switch (kind) {
      case 'amount_no_decimals': out = withDelims(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = withDelims(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = withDelims(value, 0, '.', ','); break;
      default: out = withDelims(value, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }

  /* ---------- Reveal on scroll: word headings and photo zoom ---------- */
  function initReveal() {
    var targets = $$('.js-words, .js-zoom');
    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Scroll loop shared by scroll-driven pieces ---------- */
  var scrollFns = [];
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      scrollFns.forEach(function (fn) { fn(); });
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- Header border on scroll ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    scrollFns.push(function () { header.classList.toggle('is-scrolled', window.scrollY > 8); });

    var drawer = document.querySelector('[data-menu-drawer]');
    if (drawer) {
      var close = drawer.querySelector('[data-menu-close]');
      if (close) close.addEventListener('click', function () { drawer.removeAttribute('open'); });
      drawer.addEventListener('toggle', function () {
        document.body.style.overflow = drawer.open ? 'hidden' : '';
      });
    }
    // Close desktop dropdowns on outside click or Escape
    var drops = $$('[data-nav-drop]');
    document.addEventListener('click', function (e) {
      drops.forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') drops.forEach(function (d) { d.removeAttribute('open'); });
    });
  }

  /* ---------- Signature: kid + pet match (plays on its own) ---------- */
  function initMatch() {
    $$('[data-match]').forEach(function (sec) {
      if (sec._mwMatch) sec._mwMatch.stop();
      var seasons = $$('[data-season]', sec);
      var kid = $$('.mw-match__piece--kid > [data-layer]', sec);
      var pet = $$('.mw-match__piece--pet > [data-layer]', sec);
      var bars = $$('[data-goto]', sec);
      var n = seasons.length || 1;
      var dur = parseFloat(getComputedStyle(sec).getPropertyValue('--dur')) || 3600;
      var current = 0, timers = [], visible = false, playing = false;

      function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
      function clear() { timers.forEach(clearTimeout); timers = []; }

      function show(i) {
        current = i;
        [seasons, kid, pet].forEach(function (list) {
          list.forEach(function (el, j) { el.classList.toggle('is-active', j === i); });
        });
        bars.forEach(function (b, j) {
          b.classList.toggle('is-active', j === i);
          b.classList.toggle('is-done', j < i);
          if (j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
        var tint = seasons[i] && seasons[i].getAttribute('data-tint');
        if (tint) sec.style.setProperty('--stage-bg', tint);
        // restart the progress fill
        var active = bars[i];
        if (active) { active.style.animation = 'none'; void active.offsetWidth; active.style.animation = ''; }
      }

      function cycle() {
        if (!playing) return;
        sec.classList.remove('is-leaving');
        sec.classList.add('is-matched');
        later(function () {
          if (!playing || n < 2) return;
          sec.classList.add('is-leaving');
          sec.classList.remove('is-matched');
          later(function () { show((current + 1) % n); cycle(); }, 480);
        }, dur);
      }

      function play() {
        if (playing || reduceMotion.matches) return;
        playing = true;
        sec.classList.add('is-playing');
        cycle();
      }
      function stop() {
        playing = false;
        clear();
        sec.classList.remove('is-playing', 'is-leaving');
      }

      bars.forEach(function (b) {
        b.addEventListener('click', function () {
          stop();
          sec.classList.add('is-matched');
          show(parseInt(b.getAttribute('data-goto'), 10));
          if (visible && !reduceMotion.matches) later(play, 600);
        });
      });

      show(0);
      if (reduceMotion.matches) { sec.classList.add('is-matched'); return; }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) { if (!sec.classList.contains('is-matched')) later(play, 250); else play(); }
          else stop();
        }, { threshold: 0.35 }).observe(sec);
      } else {
        play();
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else if (visible) play();
      });
      sec._mwMatch = { stop: stop };
    });
  }

  /* ---------- Statement lights up word by word ---------- */
  function initStatement() {
    $$('[data-light-up]').forEach(function (el) {
      var words = $$('.w', el);
      if (reduceMotion.matches) { words.forEach(function (w) { w.classList.add('is-lit'); }); return; }
      function update() {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        // Start lighting when the line enters the lower 85% of the screen, finish at 35%
        var start = vh * 0.85, end = vh * 0.35;
        var p = clamp((start - r.top) / (start - end + r.height * 0.5), 0, 1);
        var lit = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('is-lit', i < lit); });
      }
      scrollFns.push(update);
      update();
    });
  }

  /* ---------- Season gallery: sideways on scroll (desktop), swipe (mobile) ---------- */
  function initSeasonGallery() {
    var mq = window.matchMedia('(min-width: 990px)');
    $$('[data-season-gallery]').forEach(function (sec) {
      var track = sec.querySelector('[data-track]');
      var sticky = sec.querySelector('.seasons__sticky');
      if (!track || !sticky) return;
      var distance = 0;

      function layout() {
        var pin = mq.matches && !reduceMotion.matches;
        sec.classList.toggle('is-pinned', pin);
        track.style.transform = '';
        if (!pin) { sec.style.removeProperty('--pin-h'); distance = 0; return; }
        distance = Math.max(0, track.scrollWidth - window.innerWidth);
        sec.style.setProperty('--pin-h', (window.innerHeight + distance) + 'px');
        update();
      }
      function update() {
        if (!sec.classList.contains('is-pinned')) return;
        var r = sec.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = total > 0 ? clamp(-r.top / total, 0, 1) : 0;
        track.style.transform = 'translate3d(' + (-p * distance).toFixed(1) + 'px,0,0)';
      }
      scrollFns.push(update);
      window.addEventListener('resize', layout);
      if (mq.addEventListener) mq.addEventListener('change', layout);
      layout();
      window.addEventListener('load', layout);
    });
  }

  /* ---------- Cart helpers ---------- */
  function refreshCartCount() {
    return fetch((cfg.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
          el.classList.remove('is-bumped');
          void el.offsetWidth;
          el.classList.add('is-bumped');
        });
        var link = document.querySelector('[data-cart-link]');
        if (link) link.setAttribute('aria-label', 'Bag, ' + cart.item_count + ' items');
        return cart;
      });
  }

  var toastTimer;
  function toast(message) {
    var el = document.querySelector('.toast');
    if (!el) return;
    el.querySelector('.toast__text').textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4500);
  }

  /* ---------- Product page: kid + pet set picker ---------- */
  function initProduct() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var picker = section.querySelector('[data-picker]');
    var addBtn = section.querySelector('[data-add]');
    var errorEl = section.querySelector('[data-picker-error]');
    var totalEl = section.querySelector('[data-set-total]');
    var mainPrice = section.querySelector('[data-main-price]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var labelEl = section.querySelector('[data-add-label]');

    var pieces = $$('[data-piece]', picker).map(function (el) {
      var json = el.querySelector('[data-piece-json]');
      var product = JSON.parse(json.textContent);
      var toggle = el.querySelector('[data-piece-toggle]');
      return { el: el, product: product, toggle: toggle, variant: null, role: el.getAttribute('data-piece') };
    });

    function selected(piece) {
      return $$('fieldset.opt', piece.el).map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant(piece) {
      var p = piece.product;
      if (p.variants.length === 1 && (p.options.length === 0 || p.variants[0].title === 'Default Title')) return p.variants[0];
      var vals = selected(piece);
      if (vals.some(function (v) { return v === null; })) return null;
      return p.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      }) || null;
    }

    function markAvailability(piece) {
      var p = piece.product;
      var vals = selected(piece);
      $$('fieldset.opt', piece.el).forEach(function (fs, i) {
        $$('.opt__value', fs).forEach(function (wrap) {
          var input = wrap.querySelector('input');
          var ok = p.variants.some(function (v) {
            if (!v.available || v.options[i] !== input.value) return false;
            return v.options.every(function (o, j) { return j === i || vals[j] === null || vals[j] === o; });
          });
          wrap.classList.toggle('is-unavailable', !ok);
        });
        var chosen = fs.querySelector('[data-opt-chosen]');
        if (chosen) chosen.textContent = vals[i] || '';
      });
    }

    function enabled(piece) { return !piece.toggle || piece.toggle.checked; }

    function update() {
      var sum = 0, sumKnown = true, count = 0;
      pieces.forEach(function (piece) {
        piece.variant = findVariant(piece);
        markAvailability(piece);
        piece.el.classList.toggle('is-off', !enabled(piece));
        var priceEl = piece.el.querySelector('[data-piece-price]');
        if (piece.variant) {
          if (priceEl) priceEl.textContent = formatMoney(piece.variant.price);
          var thumb = piece.el.querySelector('[data-piece-thumb]');
          if (thumb && piece.variant.featured_image) {
            thumb.src = piece.variant.featured_image.src + (piece.variant.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          }
        }
        if (enabled(piece)) {
          count++;
          if (piece.variant) sum += piece.variant.price; else sumKnown = false;
        }
      });

      var main = pieces[0];
      if (main && main.variant) {
        var html = formatMoney(main.variant.price);
        if (mainPrice) mainPrice.innerHTML = '<span class="price"><span class="price__now"></span></span>';
        if (mainPrice) mainPrice.querySelector('.price__now').textContent = html;
        if (stickyPrice) stickyPrice.textContent = html;
      }

      var isSet = pieces.length > 1 && count > 1;
      if (totalEl) {
        totalEl.hidden = !(isSet && sumKnown);
        if (isSet && sumKnown) {
          var off = Math.round(sum * (cfg.setDiscount || 0) / 100);
          totalEl.querySelector('[data-set-now]').textContent = formatMoney(sum - off);
          totalEl.querySelector('[data-set-was]').textContent = off > 0 ? formatMoney(sum) : '';
          if (stickyPrice) stickyPrice.textContent = 'Set: ' + formatMoney(sum - off);
        }
      }
      if (labelEl) labelEl.textContent = isSet ? labelEl.getAttribute('data-set-label') : labelEl.getAttribute('data-single-label');
      var stickyBtn = section.querySelector('[data-sticky-add]');
      if (stickyBtn) stickyBtn.textContent = isSet ? 'Add the set' : 'Add to bag';

      var unavailable = pieces.some(function (pc) { return enabled(pc) && pc.variant && !pc.variant.available; });
      if (addBtn) addBtn.toggleAttribute('disabled', unavailable);
      if (unavailable && errorEl) { errorEl.hidden = false; errorEl.textContent = 'That size is sold out. Try another size.'; }
      else if (errorEl && errorEl.textContent.indexOf('sold out') > -1) { errorEl.hidden = true; }
    }

    picker.addEventListener('change', function (e) {
      var fs = e.target.closest('fieldset.opt');
      if (fs) fs.classList.remove('is-missing');
      if (errorEl && errorEl.textContent.indexOf('Pick') === 0) errorEl.hidden = true;
      update();
    });

    function add() {
      var missing = [];
      var items = [];
      pieces.forEach(function (piece) {
        if (!enabled(piece)) return;
        if (!piece.variant) {
          var vals = selected(piece);
          $$('fieldset.opt', piece.el).forEach(function (fs, i) {
            if (vals[i] === null) { fs.classList.remove('is-missing'); void fs.offsetWidth; fs.classList.add('is-missing'); missing.push(fs); }
          });
        } else {
          items.push({ id: piece.variant.id, quantity: 1 });
        }
      });
      if (missing.length) {
        var names = missing.map(function (fs) { return fs.querySelector('legend').firstChild.textContent.trim().toLowerCase(); });
        if (errorEl) { errorEl.hidden = false; errorEl.textContent = 'Pick a ' + names.join(' and ') + ' first.'; }
        missing[0].scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      if (!items.length) return;
      addBtn.classList.add('is-loading');
      fetch(cfg.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-added');
          var prev = labelEl ? labelEl.textContent : '';
          if (labelEl) labelEl.textContent = 'Added';
          setTimeout(function () { addBtn.classList.remove('is-added'); if (labelEl) labelEl.textContent = prev; }, 2200);
          toast(items.length > 1 ? 'The set is in your bag.' : 'Added to your bag.');
          return refreshCartCount();
        })
        .catch(function (err) {
          addBtn.classList.remove('is-loading');
          if (errorEl) { errorEl.hidden = false; errorEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; }
        });
    }

    if (addBtn) addBtn.addEventListener('click', add);

    // Sticky add to cart (mobile)
    var sticky = section.querySelector('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-sticky-add]');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      stickyBtn.addEventListener('click', function () {
        var ready = pieces.every(function (pc) { return !enabled(pc) || pc.variant; });
        if (ready) add();
        else { picker.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' }); setTimeout(add, 450); }
      });
    }

    // Gallery dots (mobile swipe)
    var list = section.querySelector('[data-gallery]');
    var dots = $$('[data-gallery-dots] span', section);
    if (list && dots.length) {
      list.addEventListener('scroll', function () {
        var items = list.children;
        var center = list.scrollLeft + list.clientWidth / 2;
        var idx = 0, best = Infinity;
        for (var i = 0; i < items.length; i++) {
          var c = items[i].offsetLeft + items[i].offsetWidth / 2;
          var d = Math.abs(c - center);
          if (d < best) { best = d; idx = i; }
        }
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }

    // Estimated arrival from business days
    var eta = section.querySelector('[data-eta]');
    if (eta) {
      var addBiz = function (date, days) {
        var d = new Date(date);
        while (days > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) days--; }
        return d;
      };
      var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
      var now = new Date();
      eta.textContent = 'Order today, estimated arrival ' + fmt(addBiz(now, cfg.deliveryMin || 5)) + ' to ' + fmt(addBiz(now, cfg.deliveryMax || 10)) + '.';
    }

    // Size guide dialog, filled from the Size Guide page
    var dialog = section.querySelector('[data-size-dialog]');
    var openers = $$('[data-size-guide-open]', section);
    if (dialog && typeof dialog.showModal === 'function') {
      var loaded = false;
      openers.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          dialog.showModal();
          if (loaded) return;
          loaded = true;
          fetch(btn.getAttribute('href'))
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var tables = doc.querySelector('[data-size-tables]');
              if (tables) dialog.querySelector('[data-size-dialog-body]').innerHTML = tables.innerHTML;
            })
            .catch(function () { loaded = false; });
        });
      });
      dialog.querySelector('[data-size-guide-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }

    update();
  }

  /* ---------- Collection filters: submit on change ---------- */
  function initFacets() {
    $$('[data-facets]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) form.submit();
      });
      var facets = $$('[data-facet]', form);
      document.addEventListener('click', function (e) {
        facets.forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
      });
    });
  }

  /* ---------- Cart page quantity steppers ---------- */
  function initCart() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var input = btn.parentNode.querySelector('[data-qty-input]');
      input.value = Math.max(0, parseInt(input.value || '0', 10) + parseInt(btn.getAttribute('data-qty-step'), 10));
      form.submit();
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-qty-input]')) form.submit();
    });
  }

  function init() {
    initReveal();
    initHeader();
    initMatch();
    initStatement();
    initSeasonGallery();
    initProduct();
    initFacets();
    initCart();
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-run section scripts when merchants edit in the theme editor
  document.addEventListener('shopify:section:load', function () { scrollFns = []; init(); });
})();
